export default __webpack_public_path__ + "static/media/FeverLand_07.cf60d273.png";